// extracted by mini-css-extract-plugin
export var displayNone = "_qt-6";
export var imgContainer = "_qt-2";
export var overflowHidden = "_qt-3";
export var productInfoCardButtonContainer = "_qt-5";
export var productTitleText = "_qt-4";
export var rightArrow = "_qt-1";
export var rightArrowContainer = "_qt-0";